import { render, staticRenderFns } from "./fans.vue?vue&type=template&id=7333a060&"
import script from "./fans.vue?vue&type=script&lang=js&"
export * from "./fans.vue?vue&type=script&lang=js&"
import style0 from "./fans.vue?vue&type=style&index=0&id=7333a060&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports